import { useCallback } from 'react';
import DebugService from '../services/DebugService';

const getScopedKey = (key) => {
    const host = window.location.hostname;
    let prefix = 'dev';
  
    if (host.includes('staging')) {
      prefix = 'staging';
    } else if (host.includes('finops')) {
      prefix = 'prod';
    }
  
    return `${prefix}_${key}`;
  };
  

export const useScopedLocalStorage = () => {
  const setScopedItem = useCallback((key, value) => {
    const scopedKey = getScopedKey(key);
    localStorage.setItem(scopedKey, JSON.stringify(value));
  }, []);

  const getScopedItem = useCallback((key) => {
    const scopedKey = getScopedKey(key);
    const item = localStorage.getItem(scopedKey);
    try {
      return item ? JSON.parse(item) : null;
    } catch (e) {
      DebugService.error('Failed to parse localStorage item', e);
      return null;
    }
  }, []);

  const removeScopedItem = useCallback((key) => {
    const scopedKey = getScopedKey(key);
    localStorage.removeItem(scopedKey);
  }, []);

  return {
    setScopedItem,
    getScopedItem,
    removeScopedItem,
  };
};
